import { SipTopBannerModule } from 'src/app/common/sip-top-banner/sip-top-banner.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { RouterModule } from '@angular/router';
import { FooterSeoModule } from 'src/app/common/footer-seo/footer-seo.module';
import { AbandonedCartModule } from 'src/app/common/abandoned-cart/abandoned-cart.module';
import { ZohoChatModule } from 'src/app/common/zoho-chat/zoho-chat.module';
import { VerloopChatModule } from 'src/app/common/verloop-chat/verloop-chat.module';
import { ModuleLoaderModule } from 'src/app/common/module-loader/module-loader.module';
import { HospitalFooterSeoComponent } from 'src/app/common/hospital-footer-seo/hospital-footer-seo.component';
import { HomeV2DockComponent } from 'src/app/common/home-v2-dock/home-v2-dock.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FooterSeoModule,
    ZohoChatModule,
    AbandonedCartModule,
    SipTopBannerModule,
    VerloopChatModule,
    ModuleLoaderModule,
    HospitalFooterSeoComponent,
    HomeV2DockComponent
  ],
  declarations: [MainLayoutComponent],
  exports: [MainLayoutComponent],
})
export class LayoutsModule { }
